import { AxiosResponse } from "axios";
import asyncPool from "tiny-async-pool";
import { parseIntOrDefault } from "@/utils/Number";
import { isPreSignedUrl } from "@/utils/PreSignedUrl";

export function settleDownload<T>(
  request: Promise<T>,
  onFailure: (error: unknown) => void
): Promise<T | undefined> {
  return request.catch((error) => {
    onFailure(error);

    return undefined;
  });
}

// Extra headers on a pre-signed S3 URL force a CORS preflight the bucket may reject.
export function downloadRequestHeaders(
  url: string,
  headers: Record<string, string> = {}
): Record<string, string> {
  if (isPreSignedUrl(url)) {
    return headers;
  }

  //Force no-cache for download via XHR - Bug #787
  return { ...headers, "Cache-Control": "no-cache" };
}

/** @deprecated */
export function downloadResponse(
  response: AxiosResponse,
  name: string,
  extension: string | null
) {
  download(
    response.data,
    extension ? name.replace(/\.[0-9a-zA-Z]+$/, "." + extension) : name
  );
}

export const download = (url: string, name: string, createObjectUrl = true) => {
  const a = document.createElement("a");
  a.setAttribute("download", name);
  let objectUrl;
  if (createObjectUrl) {
    objectUrl = window.URL.createObjectURL(url);
    a.href = objectUrl;
  } else {
    a.href = url;
  }
  a.download = name;
  document.body.append(a);
  a.click();
  a.remove();

  if (createObjectUrl && objectUrl) {
    window.URL.revokeObjectURL(objectUrl);
  }
};

/**
 * Configured async pool specifically for data upload
 * for users.
 *
 * @param array
 * @param iteratorFn
 */
export function simultaneousUploads<IN, OUT>(
  array: ReadonlyArray<IN>,
  iteratorFn: (generator: IN) => Promise<OUT>
): Promise<OUT[]> {
  return asyncPool(
    parseIntOrDefault(process.env.FILE_UPLOAD_POOL_SIZE, 1),
    array,
    iteratorFn
  );
}
